export const PRODUCT_CONSTRAINTS = {
    num: { maxLength: 70, label: 'Product number' },
    name: { maxLength: 252, label: 'Name' },
    description: { maxLength: 5_000, label: 'Description' },
    sku: { maxLength: 70, label: 'SKU' },
    upc: { maxLength: 31, label: 'UPC' },
};
//# sourceMappingURL=constraints.js.map